import { Messages } from '../../../../codegen/Localize';
import { IExtractTaskInfo } from '../../../../ts/models/IExtractTaskInfo';
import { setExtractRefreshPriority } from '../../../actions/spaces/SetExtractRefreshPriorityAction';
import {
  SessionServerSelectors,
  SessionSiteSelectors,
  SessionUserSelectors
} from '../../../selectors/SessionInfoSelectors';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { SiteRolesUtil } from '../../../../userManagement/services/resources/SiteRolesUtil';

export const SetExtractRefreshPriorityEntityAction: IEntityAction<IExtractTaskInfo, {}> = {
  name: EntityActionNames.TasksPriority,
  translateName: Messages.tasksSetPriority_action,
  isVisible: isVisible,
  isClickable: () => true,
  createReduxAction: setExtractRefreshPriority
};

function isVisible(tasks: IExtractTaskInfo[], state: AppState): boolean {
  return (SessionUserSelectors.isSessionServerAdmin(state) || SiteRolesUtil.isSiteAdmin(SessionSiteSelectors.siteRole(state)))
    && !SessionServerSelectors.ignoreExtractTaskPriority(state);
}
